var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Select, Table } from 'semantic-ui-react';
import { CustomPriceRow } from "../../admin/CustomPriceRow";
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
import { Help } from "../../Help";
import { GoldFishBufferCatalog, LegacyFishBufferCatalog, LiquidVolume } from "../automated-pro/RnaCatalog";
import { priceColumn } from "./EditKitForm";
import { ComponentPriceDisplay } from "./ProbeSetForm";
var BufferForm = /** @class */ (function (_super) {
    __extends(BufferForm, _super);
    function BufferForm(props) {
        var _this = _super.call(this, props) || this;
        _this.buffersHelp = React.createElement(React.Fragment, null,
            React.createElement(Help, null,
                "For the following sample types, 10 experiments require approximately:",
                React.createElement("p", null),
                React.createElement(Table, { celled: true, className: 'exp-volume-table', striped: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Sample type"),
                            React.createElement(Table.HeaderCell, null, "Reaction volume (\u00B5L)"),
                            React.createElement(Table.HeaderCell, null, "Probe Hybridization Buffer (mL)"),
                            React.createElement(Table.HeaderCell, null, "Probe Wash Buffer (mL)"),
                            React.createElement(Table.HeaderCell, null, "Amplifier Buffer (mL)"))),
                    React.createElement(Table.Body, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Whole-mount zebrafish larvae (5 dpf)"),
                            React.createElement(Table.Cell, null, "500"),
                            React.createElement(Table.Cell, null, "20"),
                            React.createElement(Table.Cell, null, "40"),
                            React.createElement(Table.Cell, null, "20")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Whole-mount nematode larvae (L3)"),
                            React.createElement(Table.Cell, null, "500"),
                            React.createElement(Table.Cell, null, "20"),
                            React.createElement(Table.Cell, null, "80"),
                            React.createElement(Table.Cell, null, "10")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Whole-mount sea urchin embryos (45 hpf)"),
                            React.createElement(Table.Cell, null, "100"),
                            React.createElement(Table.Cell, null, "2"),
                            React.createElement(Table.Cell, null, "16"),
                            React.createElement(Table.Cell, null, "2")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Whole-mount fruit fly embryos (stage 4-6)"),
                            React.createElement(Table.Cell, null, "200"),
                            React.createElement(Table.Cell, null, "8"),
                            React.createElement(Table.Cell, null, "80"),
                            React.createElement(Table.Cell, null, "22")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Whole-mount chicken embryos (stage HH 11-12)"),
                            React.createElement(Table.Cell, null, "500"),
                            React.createElement(Table.Cell, null, "20"),
                            React.createElement(Table.Cell, null, "80"),
                            React.createElement(Table.Cell, null, "20")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Whole-mount mouse embryos (E9.5)"),
                            React.createElement(Table.Cell, null, "500"),
                            React.createElement(Table.Cell, null, "30"),
                            React.createElement(Table.Cell, null, "80"),
                            React.createElement(Table.Cell, null, "30")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Mammalian cells on a chambered slide"),
                            React.createElement(Table.Cell, null, "300"),
                            React.createElement(Table.Cell, null, "12"),
                            React.createElement(Table.Cell, null, "24"),
                            React.createElement(Table.Cell, null, "12")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Bacteria in suspension"),
                            React.createElement(Table.Cell, null, "500"),
                            React.createElement(Table.Cell, null, "10"),
                            React.createElement(Table.Cell, null, "30"),
                            React.createElement(Table.Cell, null, "5")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Mammalian cells in suspension"),
                            React.createElement(Table.Cell, null, "500"),
                            React.createElement(Table.Cell, null, "10"),
                            React.createElement(Table.Cell, null, "40"),
                            React.createElement(Table.Cell, null, "5")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Tissue section (FFPE or fresh/fixed frozen) on a slide"),
                            React.createElement(Table.Cell, null, "100"),
                            React.createElement(Table.Cell, null, "6"),
                            React.createElement(Table.Cell, null, "500"),
                            React.createElement(Table.Cell, null, "6")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null,
                                "Northern blots (9 cm",
                                React.createElement("sup", null, "2"),
                                " membrane)"),
                            React.createElement(Table.Cell, null, "1500"),
                            React.createElement(Table.Cell, null, "30"),
                            React.createElement(Table.Cell, null, "0"),
                            React.createElement(Table.Cell, null, "30"))))));
        _this.goldBuffersHelp = React.createElement(React.Fragment, null,
            React.createElement(Help, null,
                "For the following sample types with representative reaction volumes, 20 experiments require approximately:",
                React.createElement("p", null),
                React.createElement(Table, { celled: true, striped: true },
                    React.createElement(Table.Header, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.HeaderCell, null, "Sample type"),
                            React.createElement(Table.HeaderCell, null, "Reaction volume (\u00B5L)"),
                            React.createElement(Table.HeaderCell, null, "HCR\u2122 HiFi Probe Hybridization Buffer (mL)"),
                            React.createElement(Table.HeaderCell, null, "HCR\u2122 HiFi Probe Wash Buffer (mL)"),
                            React.createElement(Table.HeaderCell, null, "HCR\u2122 Gold Amplifier Buffer (mL)"),
                            React.createElement(Table.HeaderCell, null, "HCR\u2122 Gold Amplifier Wash Buffer (mL)"))),
                    React.createElement(Table.Body, null,
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Sample on a slide (e.g., tissue section or adherent cells)"),
                            React.createElement(Table.Cell, null, "100"),
                            React.createElement(Table.Cell, null, "6"),
                            React.createElement(Table.Cell, null, "500"),
                            React.createElement(Table.Cell, null, "6"),
                            React.createElement(Table.Cell, null, "500")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Sample in solution (e.g., whole-mount embryo or cells in suspension)"),
                            React.createElement(Table.Cell, null, "200"),
                            React.createElement(Table.Cell, null, "8"),
                            React.createElement(Table.Cell, null, "40"),
                            React.createElement(Table.Cell, null, "8"),
                            React.createElement(Table.Cell, null, "40")),
                        React.createElement(Table.Row, null,
                            React.createElement(Table.Cell, null, "Northern blot"),
                            React.createElement(Table.Cell, null, "2000"),
                            React.createElement(Table.Cell, null, "40"),
                            React.createElement(Table.Cell, null, "N/A"),
                            React.createElement(Table.Cell, null, "40"),
                            React.createElement(Table.Cell, null, "160")))),
                React.createElement("p", null),
                "Note: HCR\u2122 HiFi Probe Wash Buffer and HCR\u2122 Gold Amplifier Wash Buffer are provided at 4x; dilute to 1x using UltraPure H\u2082O prior to use. Hence, purchasing 50 mL of HCR\u2122 HiFi Probe Wash Buffer (provided at 4x) yields 200 mL of 1x HCR\u2122 HiFi Probe Wash Buffer (sufficient for approximately 100 experiments for a sample in solution using the table above)."));
        _this.volumeOptions = function (b, t) {
            return _this.relevantBufferScales(b, t).map(function (v) {
                return {
                    text: v.valueMl > 0 ? v.valueWithUnit : 'None',
                    value: v.valueMl
                };
            });
        };
        _this.onAmplificationChange = function (_, data) {
            var scales = _this.relevantBufferScales(_this.props.catalog.hybridization, BufferType.AMP);
            _this.onVolumeChange({
                volumeMls: scales,
                defaultVolumeMl: scales[0]
            }, data, 'amp');
        };
        _this.onWashChange = function (_, data) {
            if (_this.props.legacy && _this.props.catalog instanceof LegacyFishBufferCatalog) {
                var scales = _this.relevantBufferScales(_this.props.catalog.wash, BufferType.PROBE_WASH);
                _this.onVolumeChange({
                    volumeMls: scales,
                    defaultVolumeMl: scales[0]
                }, data, 'probeWash');
            }
        };
        _this.onGoldWashChange = function (_, data) {
            if (!_this.props.legacy && _this.props.catalog instanceof GoldFishBufferCatalog) {
                var scales = _this.relevantBufferScales(_this.props.catalog.goldWash, BufferType.GOLD_PROBE_WASH);
                _this.onVolumeChange({
                    volumeMls: scales,
                    defaultVolumeMl: scales[0],
                }, data, 'goldProbeWash');
            }
        };
        _this.onGoldAmpWashChange = function (_, data) {
            if (!_this.props.legacy && _this.props.catalog instanceof GoldFishBufferCatalog) {
                var scales = _this.relevantBufferScales(_this.props.catalog.goldAmpWash, BufferType.AMP_WASH);
                _this.onVolumeChange({
                    volumeMls: scales,
                    defaultVolumeMl: scales[0],
                }, data, 'ampWash');
            }
        };
        _this.onHybridizationChange = function (_, data) {
            var scales = _this.relevantBufferScales(_this.props.catalog.hybridization, BufferType.HYB);
            _this.onVolumeChange({
                volumeMls: scales,
                defaultVolumeMl: scales[0]
            }, data, 'hybridization');
        };
        _this.relevantBufferScales = function (b, t) {
            var scales = b.volumeMls;
            if (_this.props.enableCustomScale) {
                if (t === BufferType.HYB) {
                    if (scales.findIndex(function (p) { return p.valueMl === _this.props.bufferState.hybridization.valueMl; }) < 0) {
                        scales.push(new LiquidVolume(_this.props.bufferState.hybridization.valueMl));
                    }
                }
                else if (t === BufferType.AMP) {
                    if (scales.findIndex(function (p) { return p.valueMl === _this.props.bufferState.amp.valueMl; }) < 0) {
                        scales.push(new LiquidVolume(_this.props.bufferState.amp.valueMl));
                    }
                }
                else if (t === BufferType.GOLD_PROBE_WASH) {
                    if (scales.findIndex(function (p) { return p.valueMl === _this.props.bufferState.goldProbeWash.valueMl; }) < 0) {
                        scales.push(new LiquidVolume(_this.props.bufferState.goldProbeWash.valueMl));
                    }
                }
                else if (t === BufferType.PROBE_WASH) {
                    if (scales.findIndex(function (p) { return p.valueMl === _this.props.bufferState.probeWash.valueMl; }) < 0) {
                        scales.push(new LiquidVolume(_this.props.bufferState.probeWash.valueMl));
                    }
                }
                else {
                    if (scales.findIndex(function (p) { return p.valueMl === _this.props.bufferState.ampWash.valueMl; }) < 0) {
                        scales.push(new LiquidVolume(_this.props.bufferState.ampWash.valueMl));
                    }
                }
            }
            return scales.sort(function (s1, s2) { return s1.valueMl - s2.valueMl; });
        };
        _this.onVolumeChange = function (b, data, field) {
            var val = b.volumeMls.find(function (v) { return v.valueMl === data.value; });
            var newScale = val;
            if (newScale === undefined) {
                if (!_this.props.enableCustomScale) {
                    throw new RangeError("Could not find volume " + data.value);
                }
                if (typeof data.value !== 'string') {
                    throw new Error("Invalid scale " + data.value);
                }
                var num = parseInt(data.value, 10);
                if (num === undefined || isNaN(num)) {
                    throw new Error("Invalid scale " + val);
                }
                newScale = new LiquidVolume(num);
            }
            var update = {};
            update[field] = newScale;
            _this.props.onBufferChange(update, _this.props.onUserSelection);
        };
        _this.onCustomPriceChange = function (newStateFn, callback) {
            _this.props.onBufferChange(function (oldState) {
                return {
                    customPrice: newStateFn(oldState.customPrice)
                };
            }, callback);
        };
        return _this;
    }
    BufferForm.prototype.render = function () {
        return React.createElement(Grid, { columns: 4, stackable: true },
            this.props.legacy ? React.createElement(React.Fragment, null,
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { errorPath: '/buffersComponent/hybridizationBufferMl', errors: this.props.errors, showErrors: this.props.showErrors, labelContent: React.createElement(React.Fragment, null,
                                "Probe Hybridization Buffer\u00A0",
                                this.buffersHelp), labelFor: 'buffer-probe-hybridization' },
                            React.createElement(Select, { name: 'buffer-probe-hybridization', onChange: this.onHybridizationChange, allowAdditions: this.props.enableCustomScale, search: this.props.enableCustomScale, options: this.volumeOptions(this.props.catalog.hybridization, BufferType.HYB), value: this.props.bufferState.hybridization.valueMl }))),
                    this.props.sampleType.id !== "NORTHERN_BLOT" && React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { showErrors: this.props.showErrors, errorPath: '/buffersComponent/washBufferMl', errors: this.props.errors, labelContent: React.createElement(React.Fragment, null,
                                "Probe Wash Buffer\u00A0",
                                this.buffersHelp), labelFor: 'buffer-probe-wash' },
                            React.createElement(Select, { name: 'buffer-probe-wash', onChange: this.onWashChange, allowAdditions: this.props.enableCustomScale, search: this.props.enableCustomScale, options: this.volumeOptions(this.props.catalog.wash, BufferType.PROBE_WASH), value: this.props.bufferState.probeWash.valueMl }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { showErrors: this.props.showErrors, errorPath: '/buffersComponent/amplificationBufferMl', errors: this.props.errors, labelContent: React.createElement(React.Fragment, null,
                                "Amplifier Buffer\u00A0",
                                this.buffersHelp), labelFor: 'buffer-amplification' },
                            React.createElement(Select, { name: 'buffer-amplification', onChange: this.onAmplificationChange, allowAdditions: this.props.enableCustomScale, search: this.props.enableCustomScale, options: this.volumeOptions(this.props.catalog.amplifier, BufferType.AMP), value: this.props.bufferState.amp.valueMl }))),
                    this.props.sampleType.id === "NORTHERN_BLOT" && React.createElement(Grid.Column, null),
                    priceColumn(React.createElement(ComponentPriceDisplay, { loading: this.props.priceLoading, effectivePriceCents: this.props.effectivePriceCents, listPriceCents: this.props.listPriceCents }), this.props.effectivePriceCents !== this.props.listPriceCents))) : React.createElement(React.Fragment, null,
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { showErrors: this.props.showErrors, errorPath: '/buffersComponent/hybridizationBufferMl', errors: this.props.errors, labelContent: React.createElement(React.Fragment, null,
                                "HiFi Probe Hybridization Buffer\u00A0",
                                this.goldBuffersHelp), labelFor: 'buffer-probe-hybridization' },
                            React.createElement(Select, { name: 'buffer-probe-hybridization', onChange: this.onHybridizationChange, allowAdditions: this.props.enableCustomScale, search: this.props.enableCustomScale, options: this.volumeOptions(this.props.catalog.hybridization, BufferType.HYB), value: this.props.bufferState.hybridization.valueMl }))),
                    this.props.sampleType.id !== "NORTHERN_BLOT" && React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { showErrors: this.props.showErrors, errorPath: '/buffersComponent/washBufferMl', errors: this.props.errors, labelContent: React.createElement(React.Fragment, null,
                                "HiFi Probe Wash Buffer\u00A0",
                                this.goldBuffersHelp), labelFor: 'buffer-probe-gold-wash' },
                            React.createElement(Select, { name: 'buffer-probe-gold-wash', onChange: this.onGoldWashChange, allowAdditions: this.props.enableCustomScale, search: this.props.enableCustomScale, options: this.volumeOptions(this.props.catalog.goldWash, BufferType.GOLD_PROBE_WASH), value: this.props.bufferState.goldProbeWash.valueMl })))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { showErrors: this.props.showErrors, errorPath: '/buffersComponent/amplificationBufferMl', errors: this.props.errors, labelContent: React.createElement(React.Fragment, null,
                                "Gold Amplifier Buffer\u00A0",
                                this.goldBuffersHelp), labelFor: 'buffer-amplification' },
                            React.createElement(Select, { name: 'buffer-amplification', onChange: this.onAmplificationChange, allowAdditions: this.props.enableCustomScale, search: this.props.enableCustomScale, options: this.volumeOptions(this.props.catalog.amplifier, BufferType.AMP), value: this.props.bufferState.amp.valueMl }))),
                    React.createElement(Grid.Column, null,
                        React.createElement(FieldWithErrorDisplay, { showErrors: this.props.showErrors, errors: this.props.errors, errorPath: '/buffersComponent/goldAmpWashBufferMl', labelContent: React.createElement(React.Fragment, null,
                                "Gold Amplifier Wash Buffer\u00A0",
                                this.goldBuffersHelp), labelFor: 'buffer-gold-amp-probeWash' },
                            React.createElement(Select, { name: "buffer-gold-amp-probeWash", onChange: this.onGoldAmpWashChange, allowAdditions: this.props.enableCustomScale, search: this.props.enableCustomScale, options: this.volumeOptions(this.props.catalog.goldAmpWash, BufferType.AMP_WASH), value: this.props.bufferState.ampWash.valueMl }))),
                    React.createElement(Grid.Column, { only: "tablet computer" }),
                    priceColumn(React.createElement(ComponentPriceDisplay, { loading: this.props.priceLoading, effectivePriceCents: this.props.effectivePriceCents, listPriceCents: this.props.listPriceCents }), this.props.effectivePriceCents !== this.props.listPriceCents))),
            this.props.enableCustomPrice &&
                React.createElement(CustomPriceRow, { customPrice: this.props.bufferState.customPrice, defaultEffectivePriceCents: this.props.effectivePriceCents, errors: this.props.errors, errorPathPrefix: '/buffersComponent', onPriceChange: this.onCustomPriceChange, onUserInput: this.props.onUserSelection }));
    };
    return BufferForm;
}(React.PureComponent));
export default BufferForm;
var BufferType;
(function (BufferType) {
    BufferType[BufferType["HYB"] = 0] = "HYB";
    BufferType[BufferType["AMP"] = 1] = "AMP";
    BufferType[BufferType["PROBE_WASH"] = 2] = "PROBE_WASH";
    BufferType[BufferType["GOLD_PROBE_WASH"] = 3] = "GOLD_PROBE_WASH";
    BufferType[BufferType["AMP_WASH"] = 4] = "AMP_WASH";
})(BufferType || (BufferType = {}));
//# sourceMappingURL=BufferForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-fish/BufferForm.js
// module id = 982
// module chunks = 0